import React, { useContext, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";
import { TimesheetsProvider } from "../providers/TimesheetsProvider";
import "../css/authenticatedApp.scss";
import Quote from "./Quote";
import Restore from "./Restore";
import Calendar from "./Calendar";
import Settings from "./Settings";

import Timesheet from "./Timesheet";
import JobDescription from "./JobDescription";
import Materials from "./Materials";
import PdfTimesheet from "./PdfTimesheet";

import { RestoresProvider } from "../providers/RestoresProvider";
import { QuotesProvider } from "../providers/QuotesProvider";

import { SwipeableDrawer } from "@mui/material";

import JobsheetView from "./JobsheetView";

import { JobsheetsProvider } from "../providers/JobsheetsProvider";
import Jobsheet from "./Jobsheet";
import TomTomMap from "./TomTomMap";
import { TodosProvider } from "../providers/TodosProvider";
// import Tessa from "./Tessa";
// import { TessaProvider } from "../providers/TessaProvider";
import NavBar from "./NavBar";
import MobileNav from "./MobileNav";

import { SlidersContext } from "../providers/SlidersProvider";
import IncomingCall from "./IncomingCall";
// import { customers } from "../popData";

import Timesheets from "./Timesheets";
import Quotes from "./Quotes";
import Jobsheets from "./Jobsheets";
import Restores from "./Restores";
import useNavDrawer from "../customHooks/useNavDrawer";
// const Timesheets = lazy(() => import("./Timesheets"));
// const Jobsheets = lazy(() => import("./Jobsheets"));
// const Quotes = lazy(() => import("./Quotes"));
// const Restores = lazy(() => import("./Restores"));

const TIMESHEET = "timesheet";

const AuthenticatedApp = () => {
  let { signOutGoogle, user } = useContext(AuthContext);
  const { drawer, toggleDrawer } = useNavDrawer();

  const { sliders } = useContext(SlidersContext);

  // function seedData() {
  //   if (!user.uid) {
  //     return;
  //   }

  //   // seedCustomers(user.uid);
  //   // seedRates(user.uid);
  //   // seedOperatives(user.uid);
  // }

  return (
    <div>
      {/* <button onClick={toggleSliders}>sliders ({String(sliders)})</button> */}
      {/* <button onClick={seedData}>seed data</button> */}
      <button
        // button has 0 opacity but covers the title in the navbar on tablet & mobile
        className="nav-drawer-toggle desktop-hide"
        onClick={toggleDrawer(!drawer)}
      >
        toggle nav drawer
      </button>
      <SwipeableDrawer
        anchor="left"
        open={drawer}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <MobileNav
          toggleDrawer={toggleDrawer}
          user={user}
          signOutGoogle={signOutGoogle}
        />
      </SwipeableDrawer>
      {/* <button
        onClick={() => {
          fetch("/sendEmail");
        }}
      >
        send email
      </button>{" "} */}
      <NavBar signOutGoogle={signOutGoogle} />
      {/* <p>Hello, we are now authenticated</p> */}
      <TimesheetsProvider>
        <QuotesProvider>
          <JobsheetsProvider>
            <RestoresProvider>
              <TodosProvider>
                {/* <Suspense fallback={<div>LOADING</div>}> */}
                <Switch>
                  <Route exact path="/calendar">
                    <Calendar />
                  </Route>

                  <Route path="/tom-tom-map">
                    <TomTomMap />
                  </Route>

                  <Route path="/settings">
                    <Settings />
                  </Route>

                  <Route exact path="/phone">
                    <IncomingCall />
                  </Route>

                  {sliders && (
                    <Switch>
                      <Route exact path="/">
                        <Timesheets primaryType={TIMESHEET} />
                      </Route>
                      <Route path="/timesheet">
                        <Timesheets primaryType={TIMESHEET} />
                      </Route>

                      <Route path="/quotes">
                        <Quotes />
                      </Route>
                      <Route path="/quote">
                        <Quotes />
                      </Route>

                      <Route path="/jobsheets">
                        <Jobsheets />
                      </Route>
                      <Route path="/jobsheet">
                        <Jobsheets />
                      </Route>

                      <Route path="/restores">
                        <Restores />
                      </Route>
                      <Route path="/restore">
                        <Restores />
                      </Route>
                    </Switch>
                  )}

                  {!sliders && (
                    <Switch>
                      <Route exact path="/">
                        <Timesheets primaryType={TIMESHEET} />
                      </Route>

                      <Route exact path="/quotes">
                        <Quotes />
                      </Route>

                      <Route exact path="/jobsheets">
                        <Jobsheets />
                      </Route>

                      <Route exact path="/restores">
                        <Restores />
                      </Route>

                      <Route exact path="/quote/pdf">
                        <PdfTimesheet isQuote={true} />
                      </Route>
                      <Route exact path="/:type/pdf">
                        <PdfTimesheet isQuote={false} />
                      </Route>

                      <Route exact path="/:type/materials">
                        <Materials />
                      </Route>

                      <Route exact path="/:type/jobDescription/:uid">
                        <JobDescription />
                      </Route>

                      <Route exact path="/:type/jobsheetView">
                        <JobsheetView />
                      </Route>

                      <Route path="/timesheet/:uid">
                        <Timesheet />
                      </Route>
                      <Route path="/quote/:uid">
                        <Quote />
                      </Route>
                      <Route path="/jobsheet/:uid">
                        <Jobsheet />
                      </Route>
                      <Route path="/restore/:uid">
                        <Restore />
                      </Route>
                    </Switch>
                  )}
                </Switch>
                {/* </Suspense> */}
              </TodosProvider>
            </RestoresProvider>
          </JobsheetsProvider>
        </QuotesProvider>
      </TimesheetsProvider>
    </div>
  );
};

export default AuthenticatedApp;

/* With Sliders

=> to timesheets
        / (exact)
        /timesheet
        /timesheet/jobsheetView
        /timesheet/pdf
        /timesheet/jobDescription
        /timesheet/materials

        /quote (exact)
        /quote/:uid
        /quote/jobsheetView
        /quote/pdf
        /quote/jobDescription
        /quote/materials

Without Sliders

=> to timesheets
        / (exact)

=> to timesheet
        /timesheet/:uid


=> to pdf view
        /:type/pdf

        /timesheet
        /timesheet/jobsheetView
        /timesheet/pdf
        /timesheet/jobDescription
        /timesheet/materials

  

*/
